<template>
  <v-dialog v-model="show" width="300">
    <v-card>
      <v-card-title class="title">
        Sleutel genereren
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <p>
          Weet je zeker dat je de sleutel van de huidige derde partij opnieuw wilt genereren?
        </p>
        <p>
          De actie kan niet ongedaan worden en de huidige sleutel is direct ongeldig.
        </p>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" @click="show = false">
          Sluit
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn text color="success" @click="generateKey">
          Genereer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ThirdPartyKeyGenerator',
  props: {
    show: {},
    thirdPartyIdentifier: {
      required: true,
    },
  },
  methods: {
    generateKey() {
      this.$http.post('third-party/' + this.thirdPartyIdentifier + '/key')
        .then((key => this.emit(key.data.key)));
    },

    emit(key) {
      this.$emit('key', key);
    },
  },
};
</script>
